import { FC } from "react";
import Modal from "react-modal";
import { CrossIcon } from "../../assets";
import { Button } from "../../components";
import styles from "./styles.module.scss";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onDelete: () => void;
  isLoading: boolean;
}

const Delete: FC<Props> = ({
  isOpen,
  setIsOpen,
  onDelete,
  isLoading,
}): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      shouldFocusAfterRender={false}
      onRequestClose={() => setIsOpen(false)}
      overlayClassName={styles.overlay}
      className={styles.modal}
      ariaHideApp={false}
    >
      <div className={styles.innerContainer}>
        <CrossIcon
          onClick={() => setIsOpen(false)}
          className={styles.closeBtn}
        />
        <h5>Are you sure you want to delete?</h5>
        <div className={styles.btnContainer}>
          <Button
            title={"Confirm"}
            onClick={onDelete}
            loading={isLoading}
            size={"small"}
            styleType="filled"
            backgroundColor="#FF3C3C"
          />
          <Button
            onClick={() => setIsOpen(false)}
            title={"Cancel"}
            size={"small"}
            styleType="disabled"
          />
        </div>
      </div>
    </Modal>
  );
};

export default Delete;
